import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, getDoc, getDocs, setDoc, deleteDoc, query, where, updateDoc } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import { Alert, Button, Table } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

function AdminMessagesToAdmin() {

    const [ loading, setLoading ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState();

    const [ startDateValue, setStartDateValue ] = useState(new Date());
    const [ endDateValue, setEndDateValue ] = useState(new Date());

    const [ logs, setLogs ] = useState([]);

    const employeeIdRef = useRef();
    const emailRef = useRef();

    const sortByDateAsc = (a, b) => {
        return a.timestamp.localeCompare(b.timestamp);
    }
    const sortByDateDesc = (a, b) => {
        return b.timestamp.localeCompare(a.timestamp);
    }

    const [ sortFunc, setSortFunc ] = useState(() => sortByDateAsc);

    function dateTimeToTimestamp(dt) {
        return `${dt.getFullYear()}${('0'+(dt.getMonth() + 1)).slice(-2)}${('0'+dt.getDate()).slice(-2)}${('0'+dt.getHours()).slice(-2)}${('0'+dt.getMinutes()).slice(-2)}${('0'+dt.getSeconds()).slice(-2)}`;
    }

    async function onClickSearchButton(e) {
        setLoading(true);

        setLogs([]);
        setErrorMessage(null);

        const employeeId = employeeIdRef.current.value.trim();
        const email = emailRef.current.value.trim();

        console.log(`startDateValue = ${startDateValue.getFullYear()}-${startDateValue.getMonth()+1}-${startDateValue.getDate()}`);
        console.log(`endDateValue${endDateValue.getFullYear()}-${endDateValue.getMonth()+1}-${endDateValue.getDate()}`);

        const startTimestamp = dateTimeToTimestamp(startDateValue); // `${startDateValue.getFullYear()}${('0'+(startDateValue.getMonth() + 1)).slice(-2)}`;
        const endTimestamp =  dateTimeToTimestamp(endDateValue);

        try {
            let q;
            const colRef = collection(firestore, 'messagesToAdmin');

            if (employeeId && email && startDateValue && endDateValue) {
                q = query(
                    colRef,
                    where('employeeId', '==', employeeId),
                    where('email', '==', email),
                    where('timestamp', '>=', startTimestamp),
                    where('timestamp', '<=', endTimestamp),
                );
            }
            else if (employeeId && startDateValue && endDateValue) {
                q = query(
                    colRef,
                    where('employeeId', '==', employeeId),
                    where('timestamp', '>=', startTimestamp),
                    where('timestamp', '<=', endTimestamp),
                );
            }
            else if (email && startDateValue && endDateValue) {
                q = query(
                    colRef,
                    where('email', '==', email),
                    where('timestamp', '>=', startTimestamp),
                    where('timestamp', '<=', endTimestamp),
                );
            }
            else {
                q = query(
                    colRef,
                    where('timestamp', '>=', startTimestamp),
                    where('timestamp', '<=', endTimestamp),
                );
            }

            const querySnapshot = await getDocs(q);
            const logData = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            // const uniqueEmails = new Set(logData.map(item => item.email));
            // console.log('uniqueEmails', uniqueEmails)

            let detailedLogData = [];
            for (let i = 0; i < logData.length; i++) {
                let details = await getUserDetails(logData[i].email);

                console.log('details', details);

                detailedLogData.push({
                    ...logData[i],
                    details
                });
            }

            setLogs(detailedLogData);

            if (!detailedLogData || detailedLogData.length == 0) {
                setErrorMessage("ไม่พบข้อมูล");
            }
        }
        catch (error) {
            console.error('Error fetching logs: ', error);
            setErrorMessage(JSON.stringify(error));
            setLogs([]);
        }
        setLoading(false);
    }

    async function getUserDetails(email) {
        try {
            const docRef = doc(firestore, 'users', email);
            const docSnap = await getDoc(docRef);
    
            if (docSnap.exists()) {
                return docSnap.data();
            }
            else {
                console.log(`${email} does not exist.`);
            }
        } 
        catch (error) {
            console.error('Error fetching user: ', error);
        }
        return null;
    }

    const DATETIME_PICKER_FORMAT = 'dd-MM-y h:mm:ss a';

    return (
        <div>
            <Table>
                <tbody>
                    <tr>
                        <td>รหัสพนักงาน</td>
                        <td><input type="text" ref={employeeIdRef} /></td>
                    </tr>
                    <tr>
                        <td>อีเมล์</td>
                        <td><input type="text" ref={emailRef} /></td>
                    </tr>
                    <tr>
                        <td>ตั้งแต่วันที่</td>
                        <td>
                            <DateTimePicker locale='th-TH' format={DATETIME_PICKER_FORMAT} onChange={setStartDateValue} value={startDateValue} />&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>ถึงวันที่</td>
                        <td>
                            <DateTimePicker locale='th-TH' format={DATETIME_PICKER_FORMAT} onChange={setEndDateValue} value={endDateValue} />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <Button disabled={loading} onClick={onClickSearchButton}>ค้นหา</Button>
                        </td>
                    </tr>
                </tbody>
            </Table>
            { errorMessage ? <Alert variant='danger'>{errorMessage}</Alert> : null }
            { loading ? <div className='mt-5'><Alert variant='info'>กำลังโหลด...</Alert></div> : null }
            <div className='mt-3'>
            {
                logs && logs.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                <td colSpan={7}>พบ {logs.length} ข้อความ ในช่วงเวลาที่ระบุ</td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}>
                                <td></td>
                                <td>วันที่ เวลา</td>
                                <td>รหัสพนักงาน</td>
                                <td>อีเมล์</td>
                                <td>ชื่อ</td>
                                <td>นามสกุล</td>
                                <td>ข้อความ</td>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            logs.sort(sortFunc).map((log, i) => {
                                return (
                                    <tr key={`row_${i}`}>
                                        <td>{i+1}.</td>
                                        <td>{('0'+log.day).slice(-2)}-{('0'+log.month).slice(-2)}-{log.year} {('0'+log.hour).slice(-2)}:{('0'+log.minute).slice(-2)}:{('0'+log.second).slice(-2)}</td>
                                        <td>{log.employeeId}</td>
                                        <td>{log.email}</td>
                                        <td>{log.details ? log.details.name : null}</td>
                                        <td>{log.details ? log.details.surname : null}</td>
                                        <td>{log.message}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </Table>
                :
                    null
            }
            </div>
        </div>
    );
}

export default AdminMessagesToAdmin;
